// extracted by mini-css-extract-plugin
export var card = "_80-c";
export var checkmark = "_80-k";
export var childrenContainer = "_80-6";
export var container = "_80-b";
export var disabled = "_80-9";
export var disabledChildren = "_80-a";
export var focused = "_80-1";
export var gray = "_80-s";
export var green = "_80-p";
export var icon = "_80-g";
export var iconWrapper = "_80-8";
export var imageCircle = "_80-u";
export var large = "_80-5";
export var lg = "_80-j";
export var listItemContainer = "_80-0";
export var md = "_80-i";
export var medium = "_80-4";
export var menu = "_80-f";
export var nonInteractiveBadge = "_80-m";
export var red = "_80-q";
export var rightArea = "_80-7";
export var sectionContainer = "_80-e _80-b";
export var selected = "_80-d";
export var sm = "_80-h";
export var small = "_80-3";
export var statusDot = "_80-o";
export var statusDotContainer = "_80-n";
export var text = "_80-l";
export var transparent = "_80-t";
export var xs = "_80-2";
export var yellow = "_80-r";